import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonSelect: React.FC<MprcButtonProps> = ({ text, title, children, color = "success", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonSelect.text;
    const lTitle = title || theme.buttons.ButtonSelect.title;

    return (
        <MprcButton {...rest} title={lTitle} text={lText} color={color}>{children}</MprcButton>
    );
};
